import { Suspense } from 'react';
import { AppRoutes } from '@/routes';
import { LoadingSpinner } from '@/components/common/LoadingSpinner/LoadingSpinner';
import { ErrorBoundary } from '@/components/common/ErrorBoundary/ErrorBoundary';
import { ToastProvider } from '@/components/ui/Toast';
import { useTenantValidation } from '@/hooks/useTenantValidation';
import ErrorTenantPage from '@/pages/error/ErrorTenantPage';

function App() {
  const { isValid, isLoading, tenantSlug } = useTenantValidation();

  if (isLoading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gray-50">
        <LoadingSpinner />
      </div>
    );
  }

  if (!isValid) {
    return <ErrorTenantPage tenantSlug={tenantSlug || undefined} reason="not_found" />;
  }

  return (
    <ErrorBoundary>
      <ToastProvider>
        <Suspense fallback={<LoadingSpinner />}>
          <AppRoutes />
        </Suspense>
      </ToastProvider>
    </ErrorBoundary>
  );
}

export default App;